import React from "react";

export function WebPage() {

 return <>
  <div style={{
      margin: '1rem',
      verticalAlign: 'middle',
      textAlign: 'center',
      paddingTop: '30%',
      fontSize: '3rem',
      height: '100%'
  }}>
      Web
  </div> 

</>;
}
